module.exports = __webpack_public_path__ + "static/media/edit_cover_pic.d2b1044f.png";